import React from 'react';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

/**
 * The small arrow in a live pane's header that scrolls its list back to the
 * newest entry (lists are newest first). Insights and Hot Buttons share it,
 * as on macOS and WPF: a 12 arrow in a plain 24 × 24 hit area.
 */
const JumpToLatestButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label="Jump to latest"
    title="Jump to latest"
    className="inline-flex h-6 w-6 items-center justify-center rounded-inner text-ink-secondary hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-signature"
  >
    <ArrowUpwardIcon sx={{ fontSize: 12 }} />
  </button>
);

export default JumpToLatestButton;
